import { c as _c } from "react/compiler-runtime";
import { Typography } from '@module/components/Typography/Typography';
import { useTimerQueue } from '@module/helpers/useTimerQueue';
import useChatMessageStore from '@module/stores/useChatMessageStore';
import type { FirstSponMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
import TimeConstants from '@module/utils/item';
import { useEffect } from 'react';
function FirstSponEffect() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      duration: TimeConstants.ONE_SECOND * 5
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    current,
    enqueue
  } = useTimerQueue(t0);
  let t1;
  let t2;
  if ($[1] !== enqueue) {
    t1 = () => {
      useChatMessageStore.getState().triggers.firstSpon = payload => {
        enqueue(payload.data.message);
      };
    };
    t2 = [enqueue];
    $[1] = enqueue;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!current) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== current.nick) {
    t4 = <div className="rounded-[6px] bg-tag-emphasis p-0.5"><div className="flex items-center justify-center rounded-[4px] bg-white p-2 text-center"><Typography className="whitespace-nowrap text-[13px]" variant="caption-2" weight="regular" color="black">{current.nick} 님{t3}첫 후원 감사드립니다. 축하축하~🤗🤗</Typography></div></div>;
    $[5] = current.nick;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== current.nick || $[8] !== t4) {
    t5 = <div key={current.nick} className={`-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 z-50 transform animate-fade-in-stay-fade-out duration-[${TimeConstants.ONE_SECOND * 30}ms]`}>{t4}</div>;
    $[7] = current.nick;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
export default FirstSponEffect;